import { AppAlert } from '@components/antd';
import { useAppBanner } from './hooks/use-app-banner';
import { Trans } from 'react-i18next';

export const WalletLowBanner = () => {
  const { handleNavigateToWallet } = useAppBanner();
  return (
    <AppAlert
      showIcon
      type="error"
      message={
        <p>
          <Trans
            i18nKey="heads_up_your_balance_is_running_low_to_avoid_any_disruption_load_your_wallet"
            components={[
              <span key="wallet-link" className="cursor-pointer text-red-700" onClick={handleNavigateToWallet}></span>,
            ]}
          />
        </p>
      }
    />
  );
};
